export default "__VITE_PUBLIC_ASSET__5ad726c6__"